<template>
  <div class="d-flex fl-ae fl-jc" @click.stop="onReloadClick">
    <SvgIcon
      data-cy="reload-config-button"
      :iconContent="iconContent"
      :iconAlt="iconAlt"
      :iconStyle="iconStyle"
      class="reload-config-button"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import reloadSvg from "@/assets/images/svg/reload-icon.svg";
import { useI18n } from "vue-i18n";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { hasNonEmptyOrders } from "@/utils/vue-helpers/orders.helper";
import { showConfirm } from "@/utils/vue-helpers/confirm-dialog";
import { LogService } from "@/services/logging";

export default defineComponent({
  name: "NavbarReloadConfig",
  setup() {
    const { t } = useI18n({});
    const iconStyle = "filter: contrast(170%) invert(100%);";
    const iconContent = reloadSvg;
    const iconAlt = "reload";

    /**
     * Open the reload-config modal. When the user has open orders with
     * content or money, warn first that the open order will be lost.
     *
     * @returns {Promise<void>}
     */
    async function onReloadClick(): Promise<void> {
      if (hasNonEmptyOrders.value) {
        LogService.info(
          "User clicked navbar reload-config with open orders, prompting for confirmation"
        );
        const confirmed = await showConfirm({
          title: t("common.warning"),
          message: t("posconfiguration.change-config"),
          variant: "warning",
          confirmText: t("common.yes"),
          cancelText: t("common.return"),
        });

        if (!confirmed) {
          LogService.info("User cancelled navbar reload-config");
          return;
        }
      }

      ModalModule.setStatus(ModalStatus.ReloadConfiguration);
    }

    return {
      iconContent,
      iconAlt,
      iconStyle,
      onReloadClick,
    };
  },
});
</script>
<style>
.reload-config-button {
  cursor: pointer;
}
</style>
